import { render, staticRenderFns } from "./SnsPostItemParts.vue?vue&type=template&id=2d7b3b07&scoped=true"
import script from "./SnsPostItemParts.vue?vue&type=script&lang=ts"
export * from "./SnsPostItemParts.vue?vue&type=script&lang=ts"
import style0 from "./SnsPostItemParts.vue?vue&type=style&index=0&id=2d7b3b07&prod&lang=scss&scoped=true"
import style1 from "./SnsPostItemParts.vue?vue&type=style&index=1&id=2d7b3b07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7b3b07",
  null
  
)

export default component.exports